import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

export const getMonitorList = (data: any) => {
  const url = getAgpApiUrl('monitor', 'list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  });
};

export const getMonitorDetailData = (data: any) => {
  const url = getAgpApiUrl('monitor', 'get');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  });
};

export const createMonitorRule = (data: any) => {
  const url = getAgpApiUrl('monitor', 'store');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  });
};

export const updateMonitorRuleStatus = (data: any) => {
  const url = getAgpApiUrl('monitor', 'update_status');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '编辑预警规则中，请稍后',
  });
};

export const muteMonitorEvent = (data: any) => {
  const url = getAgpApiUrl('monitor', 'mute_monitor_event');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
    loadingTip: '忽略预警，请稍后',
  });
};

export const getNoticeCount = (data: any = {}) => {
  const url = getAgpApiUrl('monitor', 'get_result_cnt');
  return smb_fetch(url, {
    method: 'GET',
    // contentType: 'application/json',
    data,
  });
};

export const getAdvertiserNoticeCount = (data: any = {}) => {
  const url = getAgpApiUrl('monitor', 'get_uid_result_cnt');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  });
};

export const getMonitorNoticeList = (data: any = {}) => {
  const url = getAgpApiUrl('monitor', 'get_result_list');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    ...data,
  });
};
